// Icon Configuration
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';

import {
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowDown,
  faArrowRight,
  faChartLine,
  faCircle,
  faCloudUploadAlt,
  faCog,
  faHandshakeAlt,
  faHeart,
  faMailBulk,
  faPaintBrush,
  faPhotoVideo,
  faPlug,
  faPlusCircle,
  faRocket,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faExclamationTriangle,
  faUsers,
  faUserTag,
  faVolumeUp,
  faCode,
  faLink,
  faEye,
  faCloud,
  faClipboardList,
  faDesktop,
  faMobile,
  faExternalLinkSquareAlt,
  faFileUser,
  faPaperPlane,
  faQuestionCircle,
  faCheckCircle,
  faPlus,
  faUsdCircle,
  faAddressBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowsH,
  faArrowToBottom,
  faBan,
  faBarcodeRead,
  faBars,
  faBell,
  faBookUser,
  faBox,
  faBriefcaseMedical,
  faBrowser,
  faBullseye,
  faCartArrowDown,
  faCartPlus,
  faChartPie,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardCheck,
  faClock,
  faCloudDownloadAlt,
  faCloudUpload,
  faCoins,
  faComment,
  faCommentAltLines,
  faCopy,
  faCreditCard,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelopeOpen,
  faExchange,
  faExpandArrowsAlt,
  faExternalLinkSquare,
  faEyeSlash,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileUpload,
  faFilter,
  faFingerprint,
  faFolder,
  faFolderOpen,
  faFolderTree,
  faFont,
  faFrown,
  faGlobe,
  faGlobeAmericas,
  faGlobeEurope,
  faHandPointer,
  faHeartbeat,
  faHeartRate,
  faHome,
  faImage,
  faImages,
  faInfo,
  faInfoCircle,
  faKey,
  faLanguage,
  faListAlt,
  faListUl,
  faLock,
  faMeh,
  faMinusCircle,
  faMousePointer,
  faPen,
  faPhone,
  faQrcode,
  faQuestion,
  faRedo,
  faRepeat,
  faSearch,
  faShoppingBasket,
  faSignOut,
  faSitemap,
  faSmile,
  faSortAlphaUp,
  faSortNumericUp,
  faSpinner,
  faStar,
  faStopwatch,
  faSyncAlt,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faUser,
  faWaveTriangle,
  faClipboardListCheck,
  faWindowRestore,
  faEnvelope,
  faGripHorizontal,
  faTools,
  faTasks,
} from '@fortawesome/pro-solid-svg-icons';
import { Component, Suspense } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { theme, Theme } from '../theme';
import { TAB_KEY } from '../../utils/keys';
import AppLoader from 'core/ui/components/AppLoader';
import { ErrorBanner } from 'core/ui/components/ErrorBanner/ErrorBanner';

library.add(
  faArrowCircleDown as IconDefinition,
  faArrowCircleUp as IconDefinition,
  faArrowDown as IconDefinition,
  faArrowRight as IconDefinition,
  faChartLine as IconDefinition,
  faCircle as IconDefinition,
  faCloudUploadAlt as IconDefinition,
  faCog as IconDefinition,
  faHandshakeAlt as IconDefinition,
  faHeart as IconDefinition,
  faMailBulk as IconDefinition,
  faPaintBrush as IconDefinition,
  faPhotoVideo as IconDefinition,
  faPlug as IconDefinition,
  faPlusCircle as IconDefinition,
  faRocket as IconDefinition,
  faSortAlphaDown as IconDefinition,
  faSortAlphaDownAlt as IconDefinition,
  faExclamationTriangle as IconDefinition,
  faUsers as IconDefinition,
  faVolumeUp as IconDefinition,
  faCode as IconDefinition,
  faLink as IconDefinition,
  faEye as IconDefinition,
  faCloud as IconDefinition,
  faClipboardList as IconDefinition,
  faDesktop as IconDefinition,
  faMobile as IconDefinition,
  faExternalLinkSquareAlt as IconDefinition,
  faFileUser as IconDefinition,
  faPaperPlane as IconDefinition,
  faQuestionCircle as IconDefinition,
  faCheckCircle as IconDefinition,
  faPlus as IconDefinition,
  faUsdCircle as IconDefinition,
  faUserTag as IconDefinition,
  faAddressBook as IconDefinition,
  faAngleDoubleLeft as IconDefinition,
  faAngleDoubleRight as IconDefinition,
  faAngleDown as IconDefinition,
  faAngleLeft as IconDefinition,
  faAngleRight as IconDefinition,
  faAngleUp as IconDefinition,
  faArchive as IconDefinition,
  faArrowsH as IconDefinition,
  faArrowToBottom as IconDefinition,
  faBan as IconDefinition,
  faBarcodeRead as IconDefinition,
  faBars as IconDefinition,
  faBell as IconDefinition,
  faBox as IconDefinition,
  faBriefcaseMedical as IconDefinition,
  faBrowser as IconDefinition,
  faBullseye as IconDefinition,
  faCartArrowDown as IconDefinition,
  faCartPlus as IconDefinition,
  faChartPie as IconDefinition,
  faCheck as IconDefinition,
  faCheckSquare as IconDefinition,
  faChevronDown as IconDefinition,
  faChevronLeft as IconDefinition,
  faChevronRight as IconDefinition,
  faChevronUp as IconDefinition,
  faClipboardCheck as IconDefinition,
  faClock as IconDefinition,
  faCloudDownloadAlt as IconDefinition,
  faCoins as IconDefinition,
  faComment as IconDefinition,
  faCommentAltLines as IconDefinition,
  faCopy as IconDefinition,
  faCreditCard as IconDefinition,
  faEdit as IconDefinition,
  faEllipsisH as IconDefinition,
  faEllipsisV as IconDefinition,
  faEnvelopeOpen as IconDefinition,
  faExchange as IconDefinition,
  faExpandArrowsAlt as IconDefinition,
  faExternalLinkSquare as IconDefinition,
  faEyeSlash as IconDefinition,
  faFileDownload as IconDefinition,
  faFileExcel as IconDefinition,
  faFileExport as IconDefinition,
  faFileImport as IconDefinition,
  faFileUpload as IconDefinition,
  faFilter as IconDefinition,
  faFingerprint as IconDefinition,
  faFolder as IconDefinition,
  faFolderOpen as IconDefinition,
  faFolderTree as IconDefinition,
  faFont as IconDefinition,
  faFrown as IconDefinition,
  faGlobe as IconDefinition,
  faGlobeAmericas as IconDefinition,
  faGlobeEurope as IconDefinition,
  faHandPointer as IconDefinition,
  faHeartbeat as IconDefinition,
  faHeartRate as IconDefinition,
  faHome as IconDefinition,
  faImage as IconDefinition,
  faImages as IconDefinition,
  faInfo as IconDefinition,
  faInfoCircle as IconDefinition,
  faKey as IconDefinition,
  faLanguage as IconDefinition,
  faListAlt as IconDefinition,
  faListUl as IconDefinition,
  faLock as IconDefinition,
  faMeh as IconDefinition,
  faMinusCircle as IconDefinition,
  faMousePointer as IconDefinition,
  faPen as IconDefinition,
  faPhone as IconDefinition,
  faQrcode as IconDefinition,
  faQuestion as IconDefinition,
  faRedo as IconDefinition,
  faRepeat as IconDefinition,
  faSearch as IconDefinition,
  faShoppingBasket as IconDefinition,
  faSignOut as IconDefinition,
  faSitemap as IconDefinition,
  faSmile as IconDefinition,
  faSortAlphaUp as IconDefinition,
  faSortNumericUp as IconDefinition,
  faSpinner as IconDefinition,
  faStar as IconDefinition,
  faStopwatch as IconDefinition,
  faSyncAlt as IconDefinition,
  faTh as IconDefinition,
  faTimes as IconDefinition,
  faTimesCircle as IconDefinition,
  faTrash as IconDefinition,
  faUser as IconDefinition,
  faWaveTriangle as IconDefinition,
  faBookUser as IconDefinition,
  faCloudUpload as IconDefinition,
  faClipboardListCheck as IconDefinition,
  faWindowRestore as IconDefinition,
  faEnvelope as IconDefinition,
  faGripHorizontal as IconDefinition,
  faTools as IconDefinition,
  faTasks as IconDefinition,
);

const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
  @font-face {
    font-family: 'Whitney';
    src: local('Whitney'),
         local('Whitney Book'),
         local('Whitney-Book'),
         url('/fonts/Whitney-Book.woff2') format('woff2'),
         url('/fonts/Whitney-Book.woff') format('woff');
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: 'Whitney';
    src: local('Whitney'),
         local('Whitney Medium'),
         local('Whitney-Medium'),
         url('/fonts/Whitney-Medium.woff2') format('woff2'),
         url('/fonts/Whitney-Medium.woff') format('woff');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Whitney';
    src: local('Whitney'),
         local('Whitney Semibold'),
         local('Whitney-Semibold'),
         url('/fonts/Whitney-Semibold.woff2') format('woff2'),
         url('/fonts/Whitney-Semibold.woff') format('woff');
    font-weight: 600;
    font-display: swap;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
  }

  body {
    color: ${props => props.theme.vars.newColor.darkGS1};
    font-size: 14px;
    font-weight: 400;
    font-family: "Whitney", Helvetica, Arial, sans-serif;
    margin: 0;
  }

  input, textarea, select, button {
    font-size: 14px;
  }

  h1, h2, h3, h4 {
    color: ${props => props.theme.vars.newColor.darkGS1};
    font-weight: 600;
    margin:0 0 .5rem 0;
    padding:0;
  }

  button, input {
    font-family: "Whitney", Helvetica, Arial, sans-serif;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-weight: 600;
    font-style:normal;
    color: ${props => props.theme.vars.color.pink};
  }

  p small {
    font-size:14px;
    color: ${props => props.theme.vars.color.pink};
  }

  p small strong {
    color: ${props => props.theme.vars.color.pink};
    font-weight: 600;
  }

  a {
    color: ${props => props.theme.vars.newColor.blue2};
    cursor: pointer;
  }

  label {
    margin: 0;
  }

  ul {
    padding-left: 0;
  }

  .focused {
    box-shadow: 0 0 0 2px rgba(94,163,255,0.5);
    border-radius: 2px;
  }

  /*
    Turn off focus ring unless user is tabbing. See comments for
    handleMouseDown() below for more info.
  */
  body:not(.user-is-tabbing) {
    *:focus {
      outline: none;
    }
    *.focused {
      box-shadow: none;
      border-radius: auto;
    }
  }
`;

export interface IState {
  error: any;
  errorInfo: any;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class UiProvider extends Component<{}, IState> {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/ban-types
  public constructor(props: {}) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  public componentDidCatch(error: any, errorInfo: any) {
    this.setState({ error, errorInfo });
  }

  public render() {
    if (this.state.errorInfo) {
      return (
        <ThemeProvider theme={theme}>
          <Suspense fallback={<AppLoader />}>
            <ErrorBanner error={this.state.error} errorInfo={this.state.errorInfo}></ErrorBanner>
          </Suspense>
        </ThemeProvider>
      );
    }
    return (
      <ThemeProvider theme={theme}>
        <>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div data-testid="UiProvider" onMouseDown={this.handleMouseDown}>
            <GlobalStyle />
            <div id="portal-root" />
            <div id="app-root">{this.props.children}</div>
          </div>
        </>
      </ThemeProvider>
    );
  }

  private handleMouseDown() {
    /*
      Simple approach to detect when a user is tabbing so that "blue border"
      focus is present for keyboard nav but not present for clicks.
      (Based on this: https://goo.gl/M2gMPp)
    */

    const handleFirstTab = (e: KeyboardEvent) => {
      if (e.keyCode === TAB_KEY) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    };
    const handleMouseDownOnce = () => {
      document.body.classList.remove('user-is-tabbing');
      window.removeEventListener('mousedown', handleMouseDownOnce);
      window.addEventListener('keydown', handleFirstTab);
    };
    window.addEventListener('keydown', handleFirstTab);
  }
}
export default UiProvider;
